import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dealer-invoice-specify-dialog" }
const _hoisted_2 = { class: "specify-summary" }
const _hoisted_3 = { class: "summary-item" }
const _hoisted_4 = { class: "summary-item" }
const _hoisted_5 = { class: "summary-item" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "specify-toolbar" }
const _hoisted_8 = { class: "sum-tip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_oio_input_number = _resolveComponent("oio-input-number")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createBlock(_component_oio_modal, {
    visible: _ctx.dialogVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "指定开票",
    width: "1200px",
    "z-index": 2000,
    "confirm-loading": _ctx.submitLoading,
    "enter-callback": _ctx.handleSubmit,
    "cancel-callback": _ctx.handleCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "已选择 " + _toDisplayString(_ctx.selectedLines.length) + " 条80单", 1),
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode("总金额："),
            _createElementVNode("b", null, _toDisplayString(_ctx.formatMoney(_ctx.totalNetAmount)), 1)
          ]),
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode("总税额："),
            _createElementVNode("b", null, _toDisplayString(_ctx.formatMoney(_ctx.totalTaxAmount)), 1)
          ])
        ]),
        _createVNode(_component_vxe_table, {
          data: _ctx.rows,
          border: "",
          "column-config": { resizable: true },
          size: "mini",
          "max-height": "320",
          class: "specify-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_column, {
              title: "指定开票内容",
              "min-width": "160"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_oio_input, {
                  value: row.specifiedInvoiceContent,
                  "onUpdate:value": ($event: any) => ((row.specifiedInvoiceContent) = $event),
                  size: "small",
                  placeholder: "必填"
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              title: "数量",
              width: "100"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_oio_input_number, {
                  value: row.quantity,
                  "onUpdate:value": ($event: any) => ((row.quantity) = $event),
                  size: "small",
                  precision: 3,
                  style: {"width":"100%"}
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              title: "金额",
              width: "110"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_oio_input_number, {
                  value: row.amount,
                  "onUpdate:value": ($event: any) => ((row.amount) = $event),
                  size: "small",
                  precision: 2,
                  style: {"width":"100%"}
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              title: "税额",
              width: "110"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_oio_input_number, {
                  value: row.taxAmount,
                  "onUpdate:value": ($event: any) => ((row.taxAmount) = $event),
                  size: "small",
                  precision: 2,
                  style: {"width":"100%"}
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              title: "税率",
              width: "90"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_oio_input_number, {
                  value: row.taxRate,
                  "onUpdate:value": ($event: any) => ((row.taxRate) = $event),
                  size: "small",
                  min: 0,
                  precision: 2,
                  style: {"width":"100%"}
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              title: "单位",
              width: "80"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_oio_input, {
                  value: row.unit,
                  "onUpdate:value": ($event: any) => ((row.unit) = $event),
                  size: "small",
                  placeholder: "必填"
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              title: "规格型号",
              width: "110"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_oio_input, {
                  value: row.specModel,
                  "onUpdate:value": ($event: any) => ((row.specModel) = $event),
                  size: "small",
                  placeholder: "选填"
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              title: "税收分类编码",
              width: "130"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_oio_input, {
                  value: row.taxCode,
                  "onUpdate:value": ($event: any) => ((row.taxCode) = $event),
                  size: "small",
                  placeholder: "必填"
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              title: "税收分类名称",
              width: "130"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_oio_input, {
                  value: row.taxCategoryName,
                  "onUpdate:value": ($event: any) => ((row.taxCategoryName) = $event),
                  size: "small",
                  placeholder: "选填"
                }, null, 8, ["value", "onUpdate:value"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              title: "操作",
              width: "60",
              align: "center"
            }, {
              default: _withCtx(({ $rowIndex }) => [
                _createElementVNode("a", {
                  class: "specify-remove-link",
                  onClick: ($event: any) => (_ctx.removeRow($rowIndex))
                }, "删除", 8, _hoisted_6)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_oio_button, {
            size: "small",
            onClick: _ctx.addRow
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加行")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("span", _hoisted_8, " 已填金额合计：" + _toDisplayString(_ctx.formatMoney(_ctx.sumAmount)) + "　已填税额合计：" + _toDisplayString(_ctx.formatMoney(_ctx.sumTaxAmount)), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading", "enter-callback", "cancel-callback"]))
}